<template>
  <div
    class="d-flex justify-content-center align-items-center vh-100 login-bg"
    :style="{ backgroundImage: 'url(/assets/img/login-bg.jpg)' }"
  >
    <div class="card shadow-sm login-card">
      <div class="card-body p-4">
        <div class="d-flex justify-content-center mb-3">
          <img
            src="/assets/img/logo_fli.png"
            alt="Logo Fastana"
            class="login-logo"
          />
        </div>
        <h5 class="mb-4 text-center">Masuk ke MONDOC</h5>

        <form @submit.prevent="handleLogin">
          <div class="mb-3">
            <label class="form-label">Email</label>
            <input
              v-model="email"
              type="email"
              class="form-control"
              required
              autofocus
            />
          </div>

          <div class="mb-3">
            <label class="form-label">Password</label>
            <input
              v-model="password"
              type="password"
              class="form-control"
              required
            />
          </div>

          <div v-if="errorMessage" class="alert alert-danger py-2" role="alert">
            {{ errorMessage }}
          </div>

          <button
            type="submit"
            class="btn btn-primary w-100"
            :disabled="loading"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            Masuk
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/services/authService";
import { saveSession, consumePostLoginRedirect } from "@/utils/auth";

export default {
  name: "LoginView",

  data() {
    return {
      email: "",
      password: "",
      loading: false,
      errorMessage: "",
    };
  },

  methods: {
    async handleLogin() {
      this.loading = true;
      this.errorMessage = "";

      try {
        const res = await login(this.email, this.password);
        saveSession(res.token_jwt, res.data);

        const redirectTo = consumePostLoginRedirect();
        this.$router.replace(redirectTo);
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message || "Login gagal, coba lagi.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-bg {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-card {
  width: 100%;
  max-width: 360px;
}

.login-logo {
  max-width: 220px;
  max-height: 120px;
  object-fit: contain;
}
</style>